import { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

import { postAttachmentsEmployes } from "../../../../../MyApi/sb/employes";


import AddEmployeAttachments from "../../../../../Components/sb/employ/employStore/employattachmentsstore";
import PageHeader from "../../../../../Components/UI/PageHeader";




const EmployeAttachmentsStore = () => {
  const {id} =useParams()
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [expired_at, setExpiredAt] = useState("");
  const mutation = useMutation(
    "postEmployeAttachments",
    (postData) => postAttachmentsEmployes(postData),
    {
      onSuccess: (data) => {
        toast.success(`${data.message}`);
      },
      onError: (error) => {
        toast.error(`${error.response.data.message}`);
      },
    }
  );

  const handlePostRequest = () => {
    const formData = new FormData();
    formData.append("name", name);
    formData.append("type", type);
    formData.append("sb_employe_id", id);
    formData.append("expired_at",expired_at)

    mutation.mutate(formData);
  };

  const isDisabled = () => {
    return !(  name && type && expired_at);
  };

  return (
    <div>
      <PageHeader
        title="Add EmployeAttachments"
        showBack
        saveButton
        handlePostRequest={handlePostRequest}
        isdisbled={isDisabled}
      />
      <AddEmployeAttachments

        setExpiredAt={setExpiredAt}
        setName={setName}
        name={name}
        type={type}
        setType={setType}
      />
    </div>
  );
};

export default EmployeAttachmentsStore;
